import clsx from 'clsx';
import { useRef, useMemo } from 'react';
import useContainerSize from '@/hooks/useContainerSize';
import BarsLegendItem from './Item';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const COL_MIN_WIDTH = 160;

const BarsLegend = _ref => {
  let {
    className,
    children
  } = _ref;
  const containerEl = useRef();
  const containerSize = useContainerSize(containerEl);
  const columns = useMemo(() => {
    const desiredColumns = Math.max(1, Math.ceil(children.length / 6));
    const availableColumns = Math.min(3, Math.floor(containerSize.width / COL_MIN_WIDTH));
    return Math.min(desiredColumns, availableColumns);
  }, [containerSize.width, children.length]); // Calculate required number of
  // rows for the number of rendered
  // children.  NOTE: required by CSS grid

  const twoColRows = Math.ceil(children.length / 2);
  const threeColRows = Math.ceil(children.length / 3);
  const cssVariables = `.${styles.container} { --two-col-rows: ${twoColRows}; --three-col-rows: ${threeColRows} }`;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("style", {
      children: cssVariables
    }), /*#__PURE__*/_jsx("ul", {
      /*
      // @ts-ignore */
      ref: containerEl,
      className: clsx(className, styles.container, columns === 2 ? styles['-twoColumns'] : columns === 3 ? styles['-threeColumns'] : ''),
      children: children
    })]
  });
};

export default BarsLegend;
export { BarsLegendItem };